module.exports = "/_next/static/images/richard-matthews@3x-02482fcf06066a5b98a272f539b5a261.png";